import { AbstractControl, ValidatorFn } from '@angular/forms';

export const mustMatch = (firstControlName: string, secondControlName?: string): ValidatorFn => {
    if (!secondControlName) {
        return (control: AbstractControl) => {
            const matchingControl = control?.parent?.get(firstControlName);

            if (control.value !== matchingControl?.value) {
                // Must return a non-null value in order to flag the control as invalid
                return {
                    mustMatch: {
                        controlToMatch: firstControlName,
                    },
                };
            } else {
                return null;
            }
        };
    } else {
        return (control: AbstractControl) => {
            const firstControl = control?.get(firstControlName);
            const secondControl = control?.get(secondControlName);

            if (firstControl?.value !== secondControl?.value) {
                // Must return a non-null value in order to flag the control as invalid
                return {
                    mustMatch: [firstControlName, secondControlName],
                };
            } else {
                return null;
            }
        };
    }
};
